import {
  AlphaIcon,
  CameraIcon,
  ResolutionIcon,
  ElementCountIcon
} from '../modules/Icons';

export const Icons = {
  Assets: <ElementCountIcon className="h-[32px] w-[32px] shrink-0" />,
  'Alpha Channel': <AlphaIcon className="h-[32px] w-[32px] shrink-0" />,
  Camera: <CameraIcon className="h-[32px] w-[32px] shrink-0" />,
  Resolution: <ResolutionIcon className="h-[32px] w-[32px] shrink-0" />,
  'Frame Rate': (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
      <rect fill="#7F898D" height="12" rx="2" width="20" x="6" y="10"></rect>
      <path
        d="M10 18.912V13.08h3.438v.885h-2.466v1.584h2.23v.885h-2.23v2.478H10zM14.324 18.912V13.08h2.013c.413 0 .759.083 1.038.25.281.167.494.397.637.69.145.29.217.62.217.99 0 .374-.072.707-.217.997-.145.29-.36.52-.642.686-.283.166-.632.248-1.046.248H14.99v-.868h1.203c.241 0 .439-.046.592-.137a.833.833 0 00.341-.376c.075-.16.113-.343.113-.55 0-.207-.038-.389-.113-.546a.801.801 0 00-.343-.368c-.154-.089-.352-.133-.595-.133h-.891v4.949h-.973zM21.991 14.683a.793.793 0 00-.31-.581c-.18-.139-.413-.208-.702-.208-.202 0-.376.033-.521.1a.783.783 0 00-.333.27.697.697 0 00-.118.39.63.63 0 00.076.317c.052.089.123.165.212.227.09.061.188.112.296.154.109.042.218.077.328.105l.503.137c.203.052.398.12.585.208.188.087.357.197.505.33.15.133.27.294.357.482.087.188.131.408.131.66 0 .342-.08.643-.241.903-.16.258-.393.46-.697.607-.303.144-.669.216-1.098.216-.418 0-.78-.07-1.088-.21a1.65 1.65 0 01-.718-.616c-.171-.27-.264-.598-.278-.985h.957a.93.93 0 00.173.507.92.92 0 00.395.302c.165.066.348.1.55.1.212 0 .397-.035.556-.103a.908.908 0 00.378-.29.742.742 0 00.139-.44.587.587 0 00-.123-.375.905.905 0 00-.339-.25 3.09 3.09 0 00-.503-.183l-.61-.17c-.442-.124-.792-.311-1.049-.562-.255-.252-.382-.587-.382-1.005 0-.344.085-.645.256-.903.173-.258.408-.458.705-.6a2.28 2.28 0 011.01-.217c.38 0 .714.072 1 .216a1.61 1.61 0 01.933 1.467h-.935z"
        fill="#1D2224"
      ></path>
    </svg>
  ),
  Formats: (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
      <path
        clipRule="evenodd"
        d="M9.264 8.067c-.419.172-.746.497-.98.975-.295.6-.284.316-.284 6.965 0 5.343.008 6.077.073 6.363.146.646.505 1.186.979 1.473L9.31 24h13.38l.258-.157c.474-.287.833-.827.979-1.473.065-.286.073-1.02.073-6.363s-.008-6.077-.073-6.363c-.146-.646-.505-1.186-.979-1.474l-.258-.156-6.621-.011c-5.25-.01-6.659.004-6.805.064zM11.54 11.4v1.16H9.793v-2.319H11.54v1.16zm10.667 0v1.16H20.46v-2.319H22.207v1.16zM11.54 16.007v1.13H9.793v-2.26H11.54v1.13zm10.667 0v1.13H20.46v-2.26H22.207v1.13zM11.54 20.613v1.158H9.793V19.453H11.54v1.16zm10.667 0v1.158H20.46V19.453H22.207v1.16z"
        fill="#7F898D"
        fillRule="evenodd"
      ></path>
    </svg>
  ),
  Format: (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
      <path
        clipRule="evenodd"
        d="M9.264 8.067c-.419.172-.746.497-.98.975-.295.6-.284.316-.284 6.965 0 5.343.008 6.077.073 6.363.146.646.505 1.186.979 1.473L9.31 24h13.38l.258-.157c.474-.287.833-.827.979-1.473.065-.286.073-1.02.073-6.363s-.008-6.077-.073-6.363c-.146-.646-.505-1.186-.979-1.474l-.258-.156-6.621-.011c-5.25-.01-6.659.004-6.805.064zM11.54 11.4v1.16H9.793v-2.319H11.54v1.16zm10.667 0v1.16H20.46v-2.319H22.207v1.16zM11.54 16.007v1.13H9.793v-2.26H11.54v1.13zm10.667 0v1.13H20.46v-2.26H22.207v1.13zM11.54 20.613v1.158H9.793V19.453H11.54v1.16zm10.667 0v1.158H20.46V19.453H22.207v1.16z"
        fill="#7F898D"
        fillRule="evenodd"
      ></path>
    </svg>
  ),
  'Render Passes': (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
      <path
        clipRule="evenodd"
        d="M15.6 9.048a7.45 7.45 0 00-1.637.305c-1.366.416-6.2 2-6.385 2.092-.77.384-.77.678 0 1.062.326.163 6.59 2.165 7.087 2.265 1.06.213 2.54.213 3.636 0 .512-.1 6.774-2.09 7.122-2.265.77-.384.77-.678 0-1.062-.17-.085-3.766-1.265-6.33-2.078-.508-.16-1.035-.257-1.748-.32a8.026 8.026 0 00-1.745 0zm-8.484 4.474c-.152.16-.14.308.039.478.28.267.41.313 6.153 2.156 1.395.447 1.83.518 3.192.518 1.35 0 1.806-.072 3.111-.492l3.11-.998c2.449-.786 2.83-.929 3.094-1.16.207-.181.229-.334.071-.501l-.11-.117-.613.204c-2.215.736-6.24 2.006-6.51 2.055-.179.033-.386.071-.46.086-.397.077-.889.106-1.774.103-1.544-.005-1.875-.079-5.267-1.17a531.963 531.963 0 01-3.395-1.101l-.53-.179-.111.118zm-.021 1.758c-.148.162-.114.367.087.516.32.24.592.343 2.633 1.003 5.183 1.677 5.122 1.662 6.74 1.655 1.46-.007 1.694-.061 5.426-1.266 3.207-1.035 3.503-1.142 3.838-1.392.206-.154.238-.381.074-.529-.099-.089-.242-.049-3.07.864-4.213 1.36-3.985 1.294-4.9 1.415-1.124.149-2.82.075-3.773-.165-.441-.11-.413-.101-3.962-1.247a345.531 345.531 0 00-2.98-.954.41.41 0 00-.113.1zm.026 1.766c-.328.348.093.69 1.33 1.082.33.105 1.779.57 3.22 1.034 1.44.464 2.852.888 3.138.94.651.122 2.592.14 3.22.03.594-.104.715-.14 4.065-1.215 3.09-.993 3.481-1.137 3.752-1.39.18-.168.19-.315.035-.48-.11-.116-.128-.118-.314-.045-.11.043-.874.296-1.7.563-5.296 1.71-5.213 1.686-6.469 1.8-1.049.096-2.315.009-3.268-.224-.422-.103-6.383-2.008-6.723-2.148-.155-.064-.18-.06-.286.053zm-.023 1.76c-.222.244-.068.488.48.762.17.084 3.765 1.265 6.33 2.078 1.49.472 3.695.472 5.185 0 2.564-.813 6.16-1.994 6.33-2.078.395-.198.573-.36.573-.526a.374.374 0 00-.103-.245c-.099-.088-.249-.046-3.206.911-3.633 1.176-3.717 1.2-4.358 1.315-.665.119-2.312.163-3.032.08-.952-.108-1.377-.226-4.718-1.309a888.602 888.602 0 00-3.304-1.067c-.046-.013-.126.023-.177.08z"
        fill="#7F898D"
        fillRule="evenodd"
      ></path>
    </svg>
  ),
  'Color Space': (
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      width="32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
      <circle cx="11.751" cy="19.3" fill="#7F898D" opacity="0.6" r="5.7"></circle>
      <circle cx="20.302" cy="19.3" fill="#7F898D" opacity="0.7" r="5.7"></circle>
      <circle cx="15.552" cy="11.7" fill="#7F898D" opacity="0.8" r="5.7"></circle>
    </svg>
  )
};

export const Icons3D = {
    Assets: <ElementCountIcon className="h-[32px] w-[32px] shrink-0" />,
    'Asset Type': (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <path
          clipRule="evenodd"
          d="M9.264 8.067c-.419.172-.746.497-.98.975-.295.6-.284.316-.284 6.965 0 5.343.008 6.077.073 6.363.146.646.505 1.186.979 1.473L9.31 24h13.38l.258-.157c.474-.287.833-.827.979-1.473.065-.286.073-1.02.073-6.363s-.008-6.077-.073-6.363c-.146-.646-.505-1.186-.979-1.474l-.258-.156-6.621-.011c-5.25-.01-6.659.004-6.805.064zM11.54 11.4v1.16H9.793v-2.319H11.54v1.16zm10.667 0v1.16H20.46v-2.319H22.207v1.16zM11.54 16.007v1.13H9.793v-2.26H11.54v1.13zm10.667 0v1.13H20.46v-2.26H22.207v1.13zM11.54 20.613v1.158H9.793V19.453H11.54v1.16zm10.667 0v1.158H20.46V19.453H22.207v1.16z"
          fill="#7F898D"
          fillRule="evenodd"
        ></path>
      </svg>
    ),
    'Texture Resolution': <ResolutionIcon className="h-[32px] w-[32px] shrink-0" />,
    'Frame Rate': (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <rect fill="#7F898D" height="12" rx="2" width="20" x="6" y="10"></rect>
        <path
          d="M10 18.912V13.08h3.438v.885h-2.466v1.584h2.23v.885h-2.23v2.478H10zM14.324 18.912V13.08h2.013c.413 0 .759.083 1.038.25.281.167.494.397.637.69.145.29.217.62.217.99 0 .374-.072.707-.217.997-.145.29-.36.52-.642.686-.283.166-.632.248-1.046.248H14.99v-.868h1.203c.241 0 .439-.046.592-.137a.833.833 0 00.341-.376c.075-.16.113-.343.113-.55 0-.207-.038-.389-.113-.546a.801.801 0 00-.343-.368c-.154-.089-.352-.133-.595-.133h-.891v4.949h-.973zM21.991 14.683a.793.793 0 00-.31-.581c-.18-.139-.413-.208-.702-.208-.202 0-.376.033-.521.1a.783.783 0 00-.333.27.697.697 0 00-.118.39.63.63 0 00.076.317c.052.089.123.165.212.227.09.061.188.112.296.154.109.042.218.077.328.105l.503.137c.203.052.398.12.585.208.188.087.357.197.505.33.15.133.27.294.357.482.087.188.131.408.131.66 0 .342-.08.643-.241.903-.16.258-.393.46-.697.607-.303.144-.669.216-1.098.216-.418 0-.78-.07-1.088-.21a1.65 1.65 0 01-.718-.616c-.171-.27-.264-.598-.278-.985h.957a.93.93 0 00.173.507.92.92 0 00.395.302c.165.066.348.1.55.1.212 0 .397-.035.556-.103a.908.908 0 00.378-.29.742.742 0 00.139-.44.587.587 0 00-.123-.375.905.905 0 00-.339-.25 3.09 3.09 0 00-.503-.183l-.61-.17c-.442-.124-.792-.311-1.049-.562-.255-.252-.382-.587-.382-1.005 0-.344.085-.645.256-.903.173-.258.408-.458.705-.6a2.28 2.28 0 011.01-.217c.38 0 .714.072 1 .216a1.61 1.61 0 01.933 1.467h-.935z"
          fill="#1D2224"
        ></path>
      </svg>
    ),
    'Frame Count': (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="none"
        viewBox="0 0 32 32"
      >
        <rect width="32" height="32" fill="#1D2224" rx="4"></rect>
        <path
          fill="#7F898D"
          fillRule="evenodd"
          d="M15.6 9.048a7.45 7.45 0 00-1.637.305c-1.366.416-6.2 2-6.385 2.092-.77.384-.77.678 0 1.062.326.163 6.59 2.165 7.087 2.265 1.06.213 2.54.213 3.636 0 .512-.1 6.774-2.09 7.122-2.265.77-.384.77-.678 0-1.062-.17-.085-3.766-1.265-6.33-2.078-.508-.16-1.035-.257-1.748-.32a8.026 8.026 0 00-1.745 0zm-8.484 4.474c-.152.16-.14.308.039.478.28.267.41.313 6.153 2.156 1.395.447 1.83.518 3.192.518 1.35 0 1.806-.072 3.111-.492l3.11-.998c2.449-.786 2.83-.929 3.094-1.16.207-.181.229-.334.071-.501l-.11-.117-.613.204c-2.215.736-6.24 2.006-6.51 2.055-.179.033-.386.071-.46.086-.397.077-.889.106-1.774.103-1.544-.005-1.875-.079-5.267-1.17a531.963 531.963 0 01-3.395-1.101l-.53-.179-.111.118zm-.021 1.758c-.148.162-.114.367.087.516.32.24.592.343 2.633 1.003 5.183 1.677 5.122 1.662 6.74 1.655 1.46-.007 1.694-.061 5.426-1.266 3.207-1.035 3.503-1.142 3.838-1.392.206-.154.238-.381.074-.529-.099-.089-.242-.049-3.07.864-4.213 1.36-3.985 1.294-4.9 1.415-1.124.149-2.82.075-3.773-.165-.441-.11-.413-.101-3.962-1.247a345.531 345.531 0 00-2.98-.954.41.41 0 00-.113.1zm.026 1.766c-.328.348.093.69 1.33 1.082.33.105 1.779.57 3.22 1.034 1.44.464 2.852.888 3.138.94.651.122 2.592.14 3.22.03.594-.104.715-.14 4.065-1.215 3.09-.993 3.481-1.137 3.752-1.39.18-.168.19-.315.035-.48-.11-.116-.128-.118-.314-.045-.11.043-.874.296-1.7.563-5.296 1.71-5.213 1.686-6.469 1.8-1.049.096-2.315.009-3.268-.224-.422-.103-6.383-2.008-6.723-2.148-.155-.064-.18-.06-.286.053zm-.023 1.76c-.222.244-.068.488.48.762.17.084 3.765 1.265 6.33 2.078 1.49.472 3.695.472 5.185 0 2.564-.813 6.16-1.994 6.33-2.078.395-.198.573-.36.573-.526a.374.374 0 00-.103-.245c-.099-.088-.249-.046-3.206.911-3.633 1.176-3.717 1.2-4.358 1.315-.665.119-2.312.163-3.032.08-.952-.108-1.377-.226-4.718-1.309a888.602 888.602 0 00-3.304-1.067c-.046-.013-.126.023-.177.08z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    Polygons: (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <g clipPath="url(#clip0_9251_173207)" fill="#7F898D">
          <path d="M23.856 10.643l-7.65-3.6a.45.45 0 00-.384 0l-7.65 3.6a.45.45 0 00-.258.407v9.9c0 .174.1.333.258.407l7.65 3.6c.003.001.005 0 .008.002a.431.431 0 00.368 0c.003-.002.005-.001.008-.002l7.65-3.6a.451.451 0 00.258-.407v-9.9c0-.174-.1-.333-.258-.407zm-7.842 3.51L9.421 11.05l6.143-2.89v1.09a.45.45 0 00.9 0V8.16l6.143 2.89-6.593 3.103zm-7.2-2.394l6.75 3.177v8.905l-6.75-3.177V11.76zm7.65 12.082v-8.905l6.75-3.177v8.905l-6.75 3.177z"></path>
          <path d="M16.013 10.6a.45.45 0 00-.45.45v1.35a.45.45 0 00.9 0v-1.35a.45.45 0 00-.45-.45zM11.322 18.981l-1.102.519a.45.45 0 10.383.814l1.102-.519a.45.45 0 00-.383-.814zM14.62 17.928a.45.45 0 00-.598-.215l-.9.423a.45.45 0 00.383.814l.9-.424a.448.448 0 00.215-.598zM21.808 19.5l-1.102-.519a.45.45 0 00-.384.814l1.102.519a.45.45 0 00.384-.814zM18.906 18.135l-.9-.423a.45.45 0 00-.383.814l.9.423a.45.45 0 10.383-.814z"></path>
        </g>
        <defs>
          <clipPath id="clip0_9251_173207">
            <path d="M0 0H18V18H0z" fill="#fff" transform="translate(7 7)"></path>
          </clipPath>
        </defs>
      </svg>
    ),
    Formats: (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <path
          d="M9 10c0-1.103.972-2 2.167-2h5.416v4c0 .553.484 1 1.084 1H22v9c0 1.103-.972 2-2.167 2h-8.666C9.972 24 9 23.103 9 22V10zm13 2h-3.833a.5.5 0 01-.5-.5V8L22 12z"
          fill="#7F898D"
        ></path>
      </svg>
    ),
    'Texture Maps': (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <g clipPath="url(#clip0_9302_93817)" fill="#7F898D">
          <path d="M14.111 24.998h4.846L25 18.955V14.11L14.111 25zM9.644 10.4L7 13.044v4.846l5.067-5.067L9.644 10.4zM16 16.756L7.757 25h4.846l5.822-5.822L16 16.756zM22.356 23.11l-1.89 1.888h3.779l-1.89-1.889zM23.111 22.354l1.89 1.889v-3.778l-1.89 1.889zM13.043 7l-2.645 2.644 2.423 2.423L17.888 7h-4.846zM7 20.465v3.778l1.889-1.89L7 20.466zM16.756 16l2.423 2.424L25 12.602V7.756L16.756 16zM7 7v4.533L11.533 7H7zM20.467 7l1.889 1.889L24.245 7h-3.778zM19.177 7.22L7.221 19.175l2.423 2.423L21.6 9.642l-2.423-2.423z"></path>
        </g>
        <defs>
          <clipPath id="clip0_9302_93817">
            <rect fill="#fff" height="18" rx="4" width="18" x="7" y="7"></rect>
          </clipPath>
        </defs>
      </svg>
    ),
    Vertices: (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="#1D2224" height="32" rx="4" width="32"></rect>
        <path
          d="M25.9 23.395c-.141-1-1.253-1.508-2.093-1.026l-.836-.845-4.16-11.431.023-1.322c.882-.21 1.373-1.24.888-2.074-.542-.933-1.9-.928-2.438.008-.465.81-.017 1.798.813 2.046l-.023 1.267-7.536 8.997-.915.254c-.403-.685-1.355-.938-2.058-.415a1.408 1.408 0 00.285 2.42c.941.405 1.97-.304 1.966-1.293l1.119-.31 11.376 2.234.973.984c-.406.704-.133 1.675.693 2.008 1.003.403 2.073-.433 1.923-1.502zm-4.17-3.127l-3.045-3.078.09-5.04 2.954 8.118zm-3.677-9.077l-.102 5.766-6.16 1.71 6.262-7.476zm-5.533 8.04l5.606-1.557 3.262 3.298-8.868-1.742z"
          fill="#7F898D"
        ></path>
      </svg>
    )
  };